import { render, staticRenderFns } from "./Checks.vue?vue&type=template&id=7b1399fa&scoped=true"
import script from "./Checks.vue?vue&type=script&lang=js"
export * from "./Checks.vue?vue&type=script&lang=js"
import style0 from "./Checks.vue?vue&type=style&index=0&id=7b1399fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1399fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b1399fa')) {
      api.createRecord('7b1399fa', component.options)
    } else {
      api.reload('7b1399fa', component.options)
    }
    module.hot.accept("./Checks.vue?vue&type=template&id=7b1399fa&scoped=true", function () {
      api.rerender('7b1399fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/rubric/form/components/questionTypes/Checks.vue"
export default component.exports